import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../shared/auth/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { ToggleSideNavService } from '../shared/toggle-side-nav.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Title } from '@angular/platform-browser';
import { normalizeRole } from '../shared/system-roles';


@Component({
  selector: 'app-sidemenu',

  imports: [RouterLink, MatIconModule, MatTooltipModule],
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.scss'
})
export class SidemenuComponent {
  auth = inject(AuthService);
  router = inject(Router);
  userRole!: string;
   proposedRoleSynonyms: Record<string, string> = {
         'nursemidwife': 'nurse / midwife',
         'consultant': 'Allied Health Professional',
         'admin': 'Hospital Admin'
      };
  private readonly distinctIconsByLink: Record<string, string> = {
    '/app/profit-margins': 'trending_up',
    '/app/dashboard': 'dashboard',
    '/app/triage': 'health_and_safety',
    '/app/organizations': 'account_balance',
    '/events': 'event_note',
    '/app/Users': 'supervisor_account',
    '/app/global-remote-doctors': 'medical_information',
    '/app/org': 'business',
    '/app/company-settings': 'settings_applications',
    '/app/org-reg': 'add_business',
    '/app/profile': 'account_circle',
    '/app/patients': 'personal_injury',
    '/app/admitted-patients': 'hotel',
    '/app/referral-requests': 'swap_horiz',
    '/app/appointments': 'event_available',
    '/app/schedule': 'schedule',
    '/app/schedules': 'calendar_view_week',
    '/app/tasks': 'fact_check',
    '/app/charges': 'request_quote',
    '/app/invoice': 'receipt_long',
    '/app/medicine-requests': 'medication',
    '/app/service-requests': 'assignment_turned_in',
    '/app/book-appointment': 'edit_calendar',
    '/app/observation-reference-ranges': 'query_stats',
    '/app/medication-dispense': 'medical_services',
    '/app/medicine-stock': 'inventory',
    '/app/services-details': 'build',
    '/app/healthcare-services': 'local_hospital',
    '/app/practitioners': 'badge',
    '/app/admission-location': 'location_city',
    '/app/supply-stock': 'inventory_2',
    '/app/document': 'article',
    '/app/patient-registration-data': 'how_to_reg',
    '/app/consultation-requests': 'forum',
    '/app/tests-requests': 'biotech',
    '/app/specimens': 'science',
    '/app/hospital-remote-doctors': 'medical_information',
    // '/app/specimens': 'science',
    // '/app/duty-roster': 'calendar_month'
  };
  menuObjects: { [key: string]: any } = {
    'superadmin': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },

        {
          title: "Organizations",
          link: "/app/organizations",
          icon: "domain"
        },
          {
      title: "Remote Doctors",
      link: "/app/global-remote-doctors",
      icon: "medical_information"
    },

        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
        {
          title: "Users",
          link: "/app/Users",
          icon: "people"
        }
      ],
      grouped_menu: [[
        'Organization', [
          {
            link: "/app/org",
            title: "Hospital Profile",
            icon: 'work'
          },
          {
            link: "/app/company-settings",
            title: "Hospital Settings",
            icon: 'settings'
          },
          {
            link: "/app/org-reg",
            title: "Hospital Registration",
            icon: 'add_business'
          },
          {
            link: "/app/terminology-migration",
            title: "Terminology Sync",
            icon: "sync"
          }

        ],
        'Settings', [
          {
            link: "/app/profile",
            title: "Profile",
            icon: 'person'
          },

        ]
      ]]
    },
    'doctor': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        // {
        //   title: "Triage",
        //   link: "/app/triage",
        //   icon: "health_and_safety"
        // },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        //admmitted-patients
        {
          link: "/app/admitted-patients",
          title: "Admitted Patients",
          icon: "local_hospital"
        },
        //referral requests
        {
          link: "/app/referral-requests",
          title: "Referral Requests",
          icon: "assignment"
        },
        {
          title: "Invoices",
          link: "/app/invoice",
          icon: "shopping_cart"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        // {
        //   link: "/app/tests-requests",
        //   title: "Tests Request",
        //   icon: "biotech"
        // },
        // {
        //   link: "/app/service-requests",
        //   title: "Service Requests",
        //   icon: "assignment"
        // },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]
    },
    'practitioner': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },
        ]
      ]]
    },
    'primaryhealthcareprovider': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          link: "/app/admitted-patients",
          title: "Admitted Patients",
          icon: "local_hospital"
        },
        {
          link: "/app/referral-requests",
          title: "Referral Requests",
          icon: "assignment"
        },
        {
          title: "Invoices",
          link: "/app/invoice",
          icon: "shopping_cart"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: "person"
          }
        ]
      ]]
    },
    'cashier': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          title: "Services",
          link: "/app/charges",
          icon: "payments"
        },
        // {
        //   title: "Claims",
        //   link: "/app/claims",
        //   icon: "shopping_cart"
        // },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          title: "Invoices",
          link: "/app/invoice",
          icon: "shopping_cart"
        },
        {
          title: "Profit Margins",
          link: "/app/profit-margins",
          icon: "trending_up"
        },


        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [
        // [
        //   'Billable Services', [
        //     {
        //       link: "/app/medicine-requests",
        //       title: "Medicine Requests",
        //       icon: "medication"

        //     },
        //     {
        //       link: "/app/tests-requests",
        //       title: "Tests Request",
        //       icon: "biotech"
        //     },
        //     {
        //       link: "/app/encounter",
        //       title: "Encounter",
        //       icon: "description"
        //     }


        //   ]


        // ],
        [
          'Settings', [
            {
              link: "/app/profile",
              title: " Profile",
              icon: 'person'
            },


          ]


        ]

      ]

    },

    'healthcareassistant': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          title: "Triage",
          link: "/app/triage",
          icon: "health_and_safety"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"

        },
        {
          link: "/app/admitted-patients",
          title: "Admitted Patients",
          icon: "local_hospital"
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'

        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        //tasks
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        // {
        //   link: "/app/tests-requests",
        //   title: "Observation Request",
        //   icon: "looks"
        // },
        {
          link: "/app/referral-requests",
          title: "Referral Requests",
          icon: "assignment"
        },
        {
          link: "/app/service-requests",
          title: "Service Requests",
          icon: "assignment"
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]
    },
    'nursemidwife': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          title: "Triage",
          link: "/app/triage",
          icon: "health_and_safety"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          link: "/app/admitted-patients",
          title: "Admitted Patients",
          icon: "local_hospital"
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        {
          title: "Invoices",
          link: "/app/invoice",
          icon: "shopping_cart"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          link: "/app/referral-requests",
          title: "Referral Requests",
          icon: "assignment"
        },
        {
          link: "/app/service-requests",
          title: "Service Requests",
          icon: "assignment"
        },
        {
          link: "/app/medicine-requests",
          title: "Medicine Requests",
          icon: "local_pharmacy"
        }
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },
        ]
      ]]
    },
    'alliedhealthprofessional': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          //services creation and edit
          title: "Services",
          link: "/app/services-details",
          icon: "build"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"

        },

        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        // {
        //   title: 'Book Appointment',
        //   link: "/app/book-appointment",
        //   icon: 'add_circle_outline'
        // },
        //tasks
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        // {
        //   link: "/app/tests-requests",
        //   title: "Observation Request",
        //   icon: "looks"
        // },
        // {
        //   link: "/app/medicine-requests",
        //   title: "Medicine Requests",
        //   icon: "medication"

        // },
        {
          link: "/app/service-requests",
          title: "Service Requests",
          icon: "assignment"
        },
        {
          link: "/app/observation-reference-ranges",
          title: "Reference Ranges",
          icon: "analytics"
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]
    },
    'patient': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/patients",
          icon: "dashboard"
        },
        {
          title: 'My Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: 'Book Appointment',
          link: "/app/book-appointment",
          icon: 'add_circle_outline'
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]
    },
    'pharmacist': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          link: "/app/medicine-requests",
          title: "Medicine Requests",
          icon: "local_pharmacy"
        },
        {
          title: "Medication Dispenses",
          link: "/app/medication-dispense",
          icon: "medical_services"
        },
        //medicine stock
        {
          link: "/app/medicine-stock",
          title: "Medicine Stock",
          icon: "inventory"
        },


        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'

        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },
        // {
        //   link: "/app/service-requests",
        //   title: "Service Requests",
        //   icon: "assignment"
        // },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]
    },


    'hospitaladmin': {
      primary_menu: [

        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
           {
          //services creation and edit
          title: "Services",
          link: "/app/services-details",
          icon: "build"
        },
        {
          title: "Healthcare Services",
          link: "/app/healthcare-services",
          icon: "medical_services"
        },
        // {
        //   link: "/app/patients",
        //   title: "Patients",
        //   icon: "people"

        // },
        // {
        //   link: "/app/admitted-patients",
        //   title: "Admitted Patients",
        //   icon: "local_hospital"
        // },
        // {
        //   link: "/app/patient-registration-data",
        //   title: "Patient Registration",
        //   icon: "person_add"
        // },
        //practitioner management
        {
          link: "/app/practitioners",
          title: "Practitioners",
          icon: "person"
        },
        {
  link: "/app/hospital-remote-doctors",
  title: "Remote Doctors",
  icon: "medical_information"
},
        {
          link: "/app/medicine-stock",
          title: "Medicine Stock",
          icon: "inventory"
        },
        {
          link: "/app/admission-location",
          title: "Admission Locations",
          icon: "location_city"
        },
        // {
        //   link: "/app/service-codes",
        //   title: "Service Request Codes",
        //   icon: "science"
        // },
        // {
        //   title: "Lab Supplies",
        //   link: "/app/lab-supplies",
        //   icon: 'inventory'


        // },
        {
          title: "Supply Stock",
          link: "/app/supply-stock",
          icon: "inventory_2"
        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: 'Billing Reports',
          link: '/app/profit-margins',
          icon: 'receipt_long'
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'
        },
        // {
        //   title: "Tasks",
        //   link: "/app/tasks",
        //   icon: "task"
        // },
        // {
        //   link: "/app/document",
        //   title: "Documents",
        //   icon: "description"
        // },
        // {
        //   link: "/app/calendar",
        //   title: "Calendar",
        //   icon: "calendar_today"
        // },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
        // {
        //   link: "/app/medicine-requests",
        //   title: "Medicine Requests",
        //   icon: "local_pharmacy"

        // },
        // {
        //   link: "/app/tests-requests",
        //   title: "Tests Request",
        //   icon: "biotech"
        // },

      ],
      grouped_menu: [[
        'Organization', [
          {
            link: "/app/org",
            title: "Hospital Profile",
            icon: 'work'
          },
          {
            link: "/app/company-settings",
            title: "Hospital Settings",
            icon: 'settings'
          },
          // {
          //   link: "/app/org-services",
          //   title: "Services",
          //   icon: 'medication'

          // },

        ]], [




        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          }


        ]


      ]
      ]


    },

    //recptionist similar to admin
    'healthcareadmin': {
      primary_menu: [
        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: "dashboard"
        },
        {
          link: "/app/patient-registration-data",
          title: "Patient Registration",
          icon: "person_add"
        },

        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: 'Book Appointment',
          link: "/app/appointments/add",
          icon: 'add_circle_outline'
        },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },
        //triage
        {
          link: "/app/triage",
          title: "Triage",
          icon: "health_and_safety"

        },
        // {
        //   link: "/app/medicine-requests",
        //   title: "Medicine Requests",
        //   icon: "local_pharmacy"

        // },
        // {
        //   link: "/app/tests-requests",
        //   title: "Tests Request",
        //   icon: "biotech"
        // },

      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]
      ]


    },
    'remotedoctor': {
      primary_menu: [

        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: 'dashboard'
        },
        // {
        //   title: "Triage",
        //   link: "/app/triage",
        //   icon: "health_and_safety"
        // },
        //REQUESTS - CONSULTATION
        {
          link: "/app/consultation-requests",
          title: "Consultation Requests",
          icon: 'chat'
        },
        // {
        //   link: "/app/patients",
        //   title: "Patients",
        //   icon: "people"

        // },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon:
            'event'
        },
        {
          title: "Add Schedule",
          link: "/app/schedule",
          icon: 'access_time'

        },
        {
          title: 'Appointments',
          link: "/app/appointments",
          icon: 'date_range'
        },
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"
        },


        // {
        //   link: "/app/service-requests",
        //   title: "Service Requests",
        //   icon: "assignment"
        // },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },

      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]

    },
    'labtechnician': {
      primary_menu: [
        {
          //services creation and edit
          title: "Services",
          link: "/app/services-details",
          icon: "build"
        },

        {
          title: "Dashboard",
          link: "/app/dashboard",
          icon: 'dashboard'
        },
        {
          link: "/app/patients",
          title: "Patients",
          icon: "people"
        },
        {
          link: "/app/tests-requests",
          title: "Tests Request",
          icon: "biotech"
        },
        {
          link: "/app/observation-reference-ranges",
          title: "Reference Ranges",
          icon: "analytics"
        },
        {
          title: "Specimens",
          link: "/app/specimens",
          icon: 'science'

        },
        // {
        //   title: "Lab Supplies",
        //   link: "/app/lab-supplies",
        //   icon: 'inventory'


        // },
        {
          title: "Supply Stock",
          link: "/app/supply-stock",
          icon: "inventory_2"
        },
        {
          title: "Schedules",
          link: "/app/schedules",
          icon: 'event'

        },
        //tasks
        {
          title: "Tasks",
          link: "/app/tasks",
          icon: "task"

        },
        // {
        //   link: "/app/service-requests",
        //   title: "Service Requests",
        //   icon: "assignment"
        // },
        {
          link: "/events",
          title: "Events",
          icon: 'event_note'
        },

      ],
      grouped_menu: [[
        'Settings', [
          {
            link: "/app/profile",
            title: " Profile",
            icon: 'person'
          },


        ]


      ]]


    },
    'eventmanager': {
  primary_menu: [
    {
      link: "/events",
      title: "Events",
      icon: 'event_note'
    },
  ],
  grouped_menu: [[
    'Settings', [
      {
        link: "/app/profile",
        title: " Profile",
        icon: 'person'
      },
    ]
  ]]
},
 'globaleventmanager': {
  primary_menu: [
    {
      link: "/events",
      title: "Events",
      icon: 'event_note'
    },
  ],
  grouped_menu: [[
    'Settings', [
      {
        link: "/app/profile",
        title: " Profile",
        icon: 'person'
      },
    ]
  ]]
},

  }

  ngOnInit() {
    const user = this.auth.user.getValue();

    console.log('🎭 Sidemenu Init - Full User Object:', user);

    if (!user) {
      console.warn('⚠️ No user found, redirecting to login');
      this.router.navigate(["login"]);
      return;
    }

    // Get role from user object - handle both 'role' and 'roles' properties
    const role = user.role || user.roles?.[0] || '';

    console.log('👤 User role from auth:', role);
    console.log('📋 User roles array:', user.roles);

    // Normalize role for menu lookup
    this.userRole = normalizeRole(role);

    console.log('🔑 Using normalized menu key:', this.userRole);
    console.log('📁 Menu exists for this role:', !!this.menuObjects[this.userRole]);

    // Subscribe to user changes
    this.auth.user.subscribe((updatedUser) => {
      if (updatedUser) {
        let updatedRole = updatedUser.role || updatedUser.roles?.[0] || '';
        this.userRole = normalizeRole(updatedRole);
        console.log('🔄 User role updated to:', this.userRole);
      }
    });

    // Subscribe to sidebar collapse state
    this.sideNavService.sideNavCollapsed.subscribe((collapsed: boolean) => {
      this.collapseMenu = collapsed;
    });

    this.normalizeMenuIcons();
    this.stripSecondaryMenuEntries();
  }

  private normalizeMenuIcons(): void {
    Object.values(this.menuObjects).forEach((menu) => {
      menu.primary_menu = menu.primary_menu.map((item: any) => ({
        ...item,
        icon: this.distinctIconsByLink[item.link] ?? item.icon
      }));

      menu.grouped_menu = menu.grouped_menu.map(([groupTitle, links]: [string, any[]]) => [
        groupTitle,
        links.map((link: any) => ({
          ...link,
          icon: this.distinctIconsByLink[link.link] ?? link.icon
        }))
      ]);
    });
  }

  private stripSecondaryMenuEntries(): void {
    Object.values(this.menuObjects).forEach((menu) => {
      menu.grouped_menu = menu.grouped_menu.filter(([groupTitle, links]: [string, any[]]) => {
        if (groupTitle.trim().toLowerCase() !== 'settings') {
          return true;
        }

        return links.some((link: any) => link.link === '/app/company-settings');
      }).map(([groupTitle, links]: [string, any[]]) => {
        if (groupTitle.trim().toLowerCase() !== 'settings') {
          return [groupTitle, links];
        }

        return [
          groupTitle,
          links.filter((link: any) => link.link === '/app/company-settings')
        ];
      });
    });
  }

  sideNavService = inject(ToggleSideNavService)
  collapseMenu = this.sideNavService.sideNavCollapsed.getValue();
}
